export default __webpack_public_path__ + "static/media/impression.c3e75af7.svg";